import { Trans } from '@lingui/react'
import { clsx } from 'clsx'
import { bool, func, shape, string } from 'prop-types'

import { TENANT_IT } from 'shared/consts'
import { withI18n } from 'shared/utils/withI18n'
import Form from 'views/components/atoms/Form'
import IconArrowLeft from 'views/components/atoms/Icon/IconArrowLeft'
import IconCaretLeft from 'views/components/atoms/Icon/IconCaretLeft'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import PreQuerySuggestions from 'views/components/organisms/PreQuerySuggestions'
import { shouldRenderPqsl } from 'views/components/organisms/PreQuerySuggestions/helpers'
import { getPlaceholderText } from 'views/components/organisms/SearchBox/helper.ts'
import SearchBoxList from 'views/components/organisms/SearchBox/SearchBoxList'
import SearchHistory from 'views/components/organisms/SearchBox/SearchHistory'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

import './SearchBoxMobile.scss'

const SearchBoxMobile = ({
  publicRuntimeConfig: {
    publicConfig: { tenant },
  },
  i18n,
  query,
  inputId,
  displayResults,
  handleClear,
  handleShowAll,
  handleSubmit,
  handleClearHistory,
  handleItemClick,
  handleQueryUpdate,
  handleInputUpdate,
  formAction,
  products,
  redirectData,
  searchHistory,
  withHighlightedProduct,
  querySuggestions,
  pageType,
}) => {
  const inputProps = {
    inputType: 'search',
    name: 'query',
    inputId,
    disableAutoCompleteAndFriends: true,
    onChange: handleInputUpdate,
    onClear: handleClear,
    value: query,
    rounded: false,
    inputClassname: 'o-SearchBox__input',
    'data-clientside-hook': 'search__input--mobile',
  }

  const searchBoxListProps = {
    mobile: true,
    query,
    displayResults,
    products,
    redirectData,
    handleShowAll,
    handleItemClick,
    formAction,
    withHighlightedProduct,
    querySuggestions,
  }

  const preQuerySuggestionsProps = {
    searchHistory,
    handleClearHistory,
    handleQueryUpdate,
    fromPreQuerySuggestions: true,
  }
  const defaultPlaceholderText = i18n._('general.label.placeholder.search')

  return (
    <div className="o-SearchBox">
      <div className="l-flex o-Searchbox__header">
        <div>
          <ButtonTransparent
            href="#"
            name="smallheader-hide-search-button"
            data-clientside-hook="hideSearchboxMobile"
          >
            {tenant === TENANT_IT ? <IconCaretLeft /> : <IconArrowLeft />}
            <span className="a-visuallyhidden">
              <Trans id="general.link.label.back" />
            </span>
          </ButtonTransparent>
        </div>
        <Form
          className="l-flex__primary"
          name="search-box"
          method="get"
          data-clientside-hook="chargeUrlSearchParams"
          action={formAction}
          onSubmit={handleSubmit}
        >
          <InputTextWithFloatingLabel {...inputProps}>
            <div>
              {getPlaceholderText({ defaultPlaceholderText, i18n, tenant })}
            </div>
          </InputTextWithFloatingLabel>
        </Form>
      </div>

      <SearchBoxList {...searchBoxListProps} />
      <div
        className={clsx(`o-PreQuerySuggestLayer__wrapper`, {
          'u-hidden': query,
        })}
        data-clientside-hook="pqsl_wrapper-mobile"
      >
        {!query && shouldRenderPqsl(pageType) && (
          <PreQuerySuggestions
            mobile
            hasSearchHistory={Boolean(searchHistory?.length)}
          >
            <SearchHistory {...preQuerySuggestionsProps} />
          </PreQuerySuggestions>
        )}
      </div>
    </div>
  )
}

SearchBoxMobile.propTypes = {
  ...SearchHistory.propTypes,
  ...SearchBoxList.propTypes,
  // comes from SearchBoxContainer
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  inputId: string.isRequired,
  formAction: string.isRequired,
  handleChange: func,
  handleClear: func,
  withHighlightedProduct: bool,
  querySuggestions: SearchBoxList.propTypes.querySuggestions,
}

SearchBoxMobile.defaultProps = {
  ...SearchHistory.defaultProps,
  ...SearchBoxList.defaultProps,
  handleChange: null,
  handleClear: null,
  querySuggestions: SearchBoxList.defaultProps.querySuggestions,
  withHighlightedProduct: false,
}

export default withI18n()(SearchBoxMobile)
